import { render } from "./CentroCustoPlanta.vue?vue&type=template&id=2ed13686&scoped=true"
import script from "./CentroCustoPlanta.vue?vue&type=script&lang=js"
export * from "./CentroCustoPlanta.vue?vue&type=script&lang=js"

import "./CentroCustoPlanta.vue?vue&type=style&index=0&id=2ed13686&lang=css"
import "./CentroCustoPlanta.vue?vue&type=style&index=1&id=2ed13686&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed13686"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QBtn,QTable,QImg,QTd,QInput,QDialog,QCard,QIcon,QCardSection,QField});
